{
  "includedProducts": {
    "seatMeal": {
      "title": "Istuinpaikka + Ateria Combo"
    },
    "seatPriority": {
      "title": "Istuinpaikka + Priority Combo"
    },
    "seatWifi": {
      "title": "Istuinpaikka + Internet Combo"
    },
    "seatCabinBaggage": {
      "title": "Istuinpaikka + Käsimatkatavara Combo"
    },
    "seatFreshMeal": {
      "text": "Northern Choice meal (smoothie, salmon rye sandwich, chocolate, coffee or tea)"
    }
  },
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Lataa (v2)"
      }
    }
  }
}
